import { render, staticRenderFns } from "./ProductServiceSalesTab.vue?vue&type=template&id=cf1fdee2&scoped=true"
import script from "./ProductServiceSalesTab.vue?vue&type=script&lang=js"
export * from "./ProductServiceSalesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1fdee2",
  null
  
)

export default component.exports